import { Link } from 'react-router-dom';
import ArticleCard from '@/components/feature/ArticleCard';
import { formatViews, getHotArticles, getSectionName, shortDate } from '@/utils/content';

export default function HotSection() {
  const hotArticles = getHotArticles(5);
  const [lead, ...rest] = hotArticles;

  if (!lead) {
    return null;
  }

  return (
    <section id="hot" className="w-full scroll-mt-20 border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.25em] text-primary-600">热门吃瓜</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              这两天讨论度最高的几件事
            </h2>
          </div>
          <Link
            to="/section/entertainment"
            className="flex w-fit cursor-pointer items-center gap-1 whitespace-nowrap text-sm font-medium text-secondary-700 transition-colors hover:text-secondary-900"
          >
            从娱乐区开始逛 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <article className="lg:col-span-7">
            <Link
              to={`/article/${lead.id}`}
              className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-80">
                <img src={lead.cover} alt={lead.coverAlt} className="h-full w-full object-top" />
                <span className="absolute left-4 top-4 flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-fire-line" /> 热度第一
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                    {getSectionName(lead.section)}
                  </span>
                  <span>{shortDate(lead.date)}</span>
                  <span>· {formatViews(lead.views)} 阅读</span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{lead.summary}</p>
              </div>
            </Link>
          </article>

          <div className="flex flex-col gap-4 lg:col-span-5">
            {rest.map((article) => (
              <ArticleCard key={article.id} article={article} variant="list" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}